<mat-stepper linear #stepper class="stepper-container" (selectionChange)="onStepChange($event)">
  <mat-step label="Preenchimento" [completed]="pdfBlob !== null" [editable]="true">
    <div class="step-content" [ngSwitch]="data.tipo">
      <app-form-divulgacao-titulos *ngSwitchCase="'DIVULGACAO_TITULOS'"
        [concursoId]="data.concursoId" (formData)="onFormReady($event)"></app-form-divulgacao-titulos>
      <app-form-ata-prova *ngSwitchCase="'ATA_PROVA_ESCRITA'"
        [concursoId]="data.concursoId" [tipoProva]="data.tipo" (formData)="onFormReady($event)"></app-form-ata-prova>
      <app-form-ata-prova *ngSwitchCase="'ATA_PLANO_TRABALHO'"
        [concursoId]="data.concursoId" [tipoProva]="data.tipo" (formData)="onFormReady($event)"></app-form-ata-prova>
      <app-form-ata-prova *ngSwitchCase="'ATA_PROVA_TITULOS'"
        [concursoId]="data.concursoId" [tipoProva]="data.tipo" (formData)="onFormReady($event)"></app-form-ata-prova>
      <app-form-ata-prova *ngSwitchCase="'ATA_PROVA_DIDATICA'"
        [concursoId]="data.concursoId" [tipoProva]="data.tipo" (formData)="onFormReady($event)"></app-form-ata-prova>
      <app-form-ata-prova *ngSwitchCase="'ATA_PROVA_ARGUICAO'"
        [concursoId]="data.concursoId" [tipoProva]="data.tipo" (formData)="onFormReady($event)"></app-form-ata-prova>
      <app-form-ata-prova *ngSwitchCase="'ATA_PROVA_ESPECIFICA'"
        [concursoId]="data.concursoId" [tipoProva]="data.tipo" (formData)="onFormReady($event)"></app-form-ata-prova>
      <app-form-retificacao-aprovados-pcd *ngSwitchCase="'RETIFICACAO_APROVADOS_PCD'"
        [concursoId]="data.concursoId" (formData)="onFormReady($event)"></app-form-retificacao-aprovados-pcd>
      <app-form-resultado-recurso *ngSwitchDefault
        [concursoId]="data.concursoId" [tipoRecurso]="data.tipo" (formData)="onFormReady($event)"></app-form-resultado-recurso>
    </div>
    <div class="step-actions">
      <button mat-stroked-button color="warn" (click)="dialogRef.close()">Cancelar</button>
      <button mat-raised-button color="primary" (click)="gerarPreview()" [disabled]="loading || !formValido()">
        <span *ngIf="!loading">Gerar Pré-visualização</span>
        <mat-spinner *ngIf="loading" diameter="25"></mat-spinner>
      </button>
    </div>
  </mat-step>

  <mat-step label="Revisão" [completed]="downloaded" [editable]="true">
    <div class="step-content">
      <div class="aviso-fonte">
        <mat-icon color="warn">warning</mat-icon>
        <span>
          <strong>Atenção:</strong> Antes de utilizar este documento, confira se o modelo está atualizado consultando a
          <a href="https://www.sg.unicamp.br/gde/procedimentos-para-realizacao/concurso-professor-doutor#Procedimentos" target="_blank" rel="noopener">versão oficial no Manual de Orientação</a> (seção <strong>Procedimentos &gt; Manual de Orientação</strong>).
          Em caso de divergência, entre em contato com a equipe de desenvolvimento pelo menu <strong>"Dúvidas"</strong> do sistema.
        </span>
      </div>
      <app-pdf-viewer *ngIf="pdfBlob" [pdfBlob]="pdfBlob"></app-pdf-viewer>
    </div>
    <div class="step-actions">
      <button mat-stroked-button color="primary" matStepperPrevious>Voltar e Editar</button>
      <button mat-raised-button color="primary" (click)="download()">
        <mat-icon>download</mat-icon> Baixar arquivo PDF
      </button>
      <button mat-raised-button color="primary" (click)="downloadDocx()" [disabled]="loadingDocx">
        <mat-icon *ngIf="!loadingDocx">download</mat-icon>
        <mat-spinner *ngIf="loadingDocx" diameter="20"></mat-spinner>
        <span>Baixar arquivo Word</span>
      </button>
    </div>
  </mat-step>

  <mat-step label="Concluído" [editable]="true" [state]="downloaded ? 'done' : 'number'">
    <div class="step-content">
      <mat-card class="card-success">
        <mat-icon>check_circle</mat-icon>
        <span>Download realizado com sucesso. Você pode fechar esta janela ou voltar para baixar em outro formato.</span>
      </mat-card>
    </div>
    <div class="step-actions">
      <button mat-stroked-button color="primary" matStepperPrevious>Voltar</button>
      <button mat-raised-button color="primary" (click)="dialogRef.close()">Fechar</button>
    </div>
  </mat-step>
</mat-stepper>
